<template>
<div>
    <Navbar />
    <Breadcrumbs></Breadcrumbs>
    <EmployeesTimelineTrip/>
    <Footer />
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import EmployeesTimelineTrip from '@/components/employees/EmployeesTimelineTrip.vue'
import Footer from '@/components/Footer.vue';

export default {
    components: {
        Navbar,
        EmployeesTimelineTrip,
        Footer
    }
}
</script>

<style scoped>

</style>